import { useRouteError } from "react-router-dom";

/**
 * Route `errorElement` that hands a render error back to React: the data
 * router's built-in error screen would otherwise catch it first, and the app's
 * translated `<ErrorBoundary>` (wrapping the router in `main.jsx`) would never
 * show.
 */
export default function RethrowRouteError() {
  throw useRouteError();
}
